import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import moment from "moment"
import EditUser from './edit/EditUser'
import {message, Switch, Modal} from "antd"
import {editUser} from "../../../services/api/UserService"
import {getLocalData} from "../../../services/StorageServices"
import {parseJwt} from "../../../helpers/parseToken"

UserTableItem.propTypes = {
    user: PropTypes.object
}

function UserTableItem(props) {
    const {user} = props
    const [isActive, setIsActive] = useState(user.is_active)

    const _onChangeActive = (checked) => {
        setIsActive(checked)

        _updateActive(checked)
    }

    const _updateActive = async (checked) => {
        try {
            const payload = {
                is_active: checked
            }

            Modal.confirm({
                title: `Bạn muốn ${!isActive ? 'bật' : 'tắt'} user này?`,
                onOk: async () => {
                    const {success, message: error} = await editUser(user._id, payload)

                    if (!success) {
                        setIsActive(!checked)
                        return message.error(error)
                    }

                    message.success('Change active user success.')
                },
                onCancel() {
                    setIsActive(!checked)
                }
            })
        } catch (e) {
            message.error(e.message)
        }
    }

    useEffect(() => {
        setIsActive(user.is_active)
    }, [user])

    const token = getLocalData('accessToken')
    const users = token !== '' ? parseJwt(token).permissions : []

    return (
        <tr className='UserListItem'>
            <td className="UserName">{user.username}</td>
            <td className="CreatedDate">{moment(user.created_at).format('hh:mm DD/MM/YYYY')}</td>
            <td className="StatusNew">
                {
                    users.hasOwnProperty('user_management') &&
                    <Switch
                        checkedChildren="Active"
                        unCheckedChildren="Deactivate"
                        checked={isActive}
                        onClick={_onChangeActive}
                    />
                }
            </td>
            <td className="Roles">
                {
                    user.hasOwnProperty('roles') && user.roles.length > 0 && user.roles.map((item) => (
                        <span key={item._id}>{item.name}</span>
                    ))
                }
            </td>
            <td className="Actions">
                {
                    users.hasOwnProperty('user_management') &&
                    <EditUser {...props} userId={user._id}/>
                }
            </td>
        </tr>
    )
}

export default UserTableItem
